export default function CTABanner() {
  return (
    <section className="relative w-full h-[380px] md:h-[460px] overflow-hidden">
      <img
        src="https://readdy.ai/api/search-image?query=Expansive%20flat%20lay%20composition%20featuring%20diverse%20fashion%20products%20including%20sneakers%20hoodies%20sunglasses%20bags%20and%20accessories%20arranged%20in%20editorial%20style%20on%20warm%20cream%20linen%20surface%20with%20soft%20directional%20sunlight%20creating%20long%20gentle%20shadows%20luxurious%20yet%20approachable%20aesthetic%20harmonious%20palette%20of%20ivory%20sand%20terracotta%20and%20olive%20tones%20inspirational%20shopping%20lifestyle%20photography%20with%20ample%20copy%20space&width=1800&height=800&seq=cta-bg-v2&orientation=landscape"
        alt="Superbuy Spreadsheet ready to shop"
        title="Superbuy Spreadsheet - Ready to Shop"
        className="absolute inset-0 w-full h-full object-cover object-top"
        loading="lazy"
      />
      <div className="absolute inset-0 bg-gradient-to-b from-black/40 via-black/25 to-black/40"></div>

      <div className="relative z-10 w-full h-full flex flex-col items-center justify-center px-4">
        <div className="text-center max-w-2xl">
          <h2 className="text-4xl md:text-6xl lg:text-7xl font-heading font-bold text-white leading-none">
            ready to shop?
          </h2>
          <p className="mt-4 text-base md:text-lg text-white/80 leading-relaxed">
            Browse the most complete superbuy spreadsheet link directory.<br />
            All links verified, all categories curated, updated every day.
          </p>
          <div className="mt-8">
            <a
              href="https://kaspreadsheet.com/"
              target="_blank"
              rel="noopener nofollow"
              className="inline-flex items-center gap-3 px-6 py-3 bg-white text-foreground-950 rounded-md font-semibold text-sm hover:bg-white/90 transition-all whitespace-nowrap cursor-pointer"
            >
              buy it now
              <span className="w-8 h-8 rounded-full bg-foreground-950 flex items-center justify-center">
                <i className="ri-arrow-right-up-line text-white text-sm"></i>
              </span>
            </a>
          </div>
        </div>
      </div>
    </section>
  );
}